<template>
  <div
    v-if="showModal"
    class="fixed z-10 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >

      <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
      <div
        class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
      >
        <div class="sm:flex sm:items-start">
          <div
            class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10"
          >
            <!-- Heroicon name: outline/exclamation -->
            <svg
              class="h-6 w-6 text-green-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3
              class="text-lg leading-6 font-medium text-gray-900"
              id="modal-title"
            >
              <!-- {{ data.caption }} -->
              Тестирование завершено.
            </h3>
            <div class="mt-2">
              <!-- <p v-html="data.message" class="text-sm text-gray-500"></p> -->
                <p v-if="data.is_chapter_closed" class="text-green-700 font-bold">Глава пройдена!</p>
                <p>Вопросов в тестировании: <strong>{{ data.exams_qnt }}</strong></p>
                <p>Верно отвеченных: <strong>{{ data.exams_done }}</strong></p>
                <p>Ваша оценка:
                    <strong>
                        <span v-if="data.grade>=65" class="text-green-700">{{ data.grade }}%</span>
                        <span v-else class="text-red-700">{{ data.grade }}%</span>
                    </strong>
                </p>
                <p v-if="data.is_grade_updated" class="text-green-700 font-bold">Это ваш лучший результат для этой Главы!</p>
                <p v-if="(data.grade<65) && (data.chapter_status==1)" class="text-red-700 font-bold">Этого недостаточно для завершения данной Главы.</p>
            </div>
          </div>
        </div>

        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse flex justify-between">
          <!--
          <button
            @click.prevent="mrOk()"
            type="button"
            data-bs-dismiss="modal"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
          >
            Ok
          </button>
          -->

          <router-link
            :to="{
              name: 'course_show',
              params: { id: data.course_id },
            }"
            class="text-gray-900 bg-green-300 hover:bg-green-500 px-5 py-3 rounded-md flex-initial font-bold"
            >Список Глав</router-link
          >
          <router-link
            v-if="data.next_chapter && (data.chapter_status==5)"
            :to="{
              name: 'chapter_show',
              params: { id: data.next_chapter },
            }"
            class="text-gray-900 bg-green-300 hover:bg-green-500 px-5 py-3 rounded-md flex-initial font-bold"
            >Следующая Глава</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    //   okCaption: "Да",
      showModal: false,
    };
  },
  props: { data: Object },
  mounted() {
    if (this.data.show) this.showModalForm();
    // if (this.data.okCaption) this.okCaption = this.data.okCaption;
  },
  watch: {
    "data.show": function () {
      if (this.data.show) this.showModalForm();
      else this.hideModalForm();
    },
  },
  methods: {

    mrOk() {
    //   this.$emit("mrok", this.data.id);
      this.$parent.ModalData.show = false;
    //   this.$parent.ModalData.id = 0;
    },

    showModalForm() {
      this.showModal = true;
    },
    hideModalForm() {
      this.showModal = false;
    },
  },
};
</script>